//this javascript file is used as a directory for all of the images in the asset folder
//import the location of each image with a given name an export default
import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import atsign from '../assets/atsign.svg';
import atsignnew from '../assets/atsignnew.png';

import scene01 from '../assets/comic/scene01.png';
import scene01LQIP from '../assets/comic/scene01LQIP.png';
import scene02 from '../assets/comic/scene02_dyna_resize.png';
import scene02LQIP from '../assets/comic/scene02LQIP.png';
import scene03 from '../assets/comic/scene03.png';
import scene03LQIP from '../assets/comic/scene03LQIP.png';
import scene04 from '../assets/comic/scene04.png';
import scene04LQIP from '../assets/comic/scene04LQIP.png';


//after importing all of the image addresses and assigning them a name create a list of the images
const image_list = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  atsign,
  atsignnew,
  scene01,
  scene01LQIP,
  scene02,
  scene02LQIP,
  scene03,
  scene03LQIP,
  scene04,
  scene04LQIP,
};

//export the list of images
export default image_list